var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMachineLearningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "machine-learning-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Extra-Large-Copy",
    transform: "translate(-214, -486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "machine-learning-svgrepo-com",
    transform: "translate(220, 493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5,35.1562535 C19.2007192,35.1590186 16.1200463,33.5066096 14.2973437,30.7565156 L16.6401562,29.1992344 C17.9431032,31.1631152 20.1432016,32.343725 22.5,32.343725 C24.8567984,32.343725 27.0568968,31.1631152 28.3598438,29.1992344 L30.7026563,30.7565156 C28.8799537,33.5066096 25.7992808,35.1590186 22.5,35.1562535 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125,19.6875 C26.5716991,19.6875 25.3125,20.9466991 25.3125,22.5 C25.3125,24.0533009 26.5716991,25.3125 28.125,25.3125 C29.6783009,25.3125 30.9375,24.0533009 30.9375,22.5 C30.9448648,21.7518452 30.6509142,21.0321877 30.1218633,20.5031367 C29.5928123,19.9740858 28.8731548,19.6801352 28.125,19.6875 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875,19.6875 C15.3216991,19.6875 14.0625,20.9466991 14.0625,22.5 C14.0625,24.0533009 15.3216991,25.3125 16.875,25.3125 C18.4283009,25.3125 19.6875,24.0533009 19.6875,22.5 C19.6948648,21.7518452 19.4009142,21.0321877 18.8718633,20.5031367 C18.3428123,19.9740858 17.6231548,19.6801352 16.875,19.6875 L16.875,19.6875 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1875,22.5 L42.1875,19.6875 L39.375,19.6875 L39.375,14.0625 C39.3715126,10.957344 36.855156,8.44098742 33.75,8.4375 L30.9375,8.4375 L30.9375,2.8125 L28.125,2.8125 L28.125,8.4375 L16.875,8.4375 L16.875,2.8125 L14.0625,2.8125 L14.0625,8.4375 L11.25,8.4375 C8.14484397,8.44098742 5.62848742,10.957344 5.625,14.0625 L5.625,19.6875 L2.8125,19.6875 L2.8125,22.5 L5.625,22.5 L5.625,29.53125 L2.8125,29.53125 L2.8125,32.34375 L5.625,32.34375 L5.625,36.5625 C5.62848742,39.667656 8.14484397,42.1840126 11.25,42.1875 L33.75,42.1875 C36.855156,42.1840126 39.3715126,39.667656 39.375,36.5625 L39.375,32.34375 L42.1875,32.34375 L42.1875,29.53125 L39.375,29.53125 L39.375,22.5 L42.1875,22.5 Z M36.5625,36.5625 C36.5607176,38.115062 35.302562,39.3732176 33.75,39.375 L11.25,39.375 C9.69743802,39.3732176 8.43928237,38.115062 8.4375,36.5625 L8.4375,14.0625 C8.43928237,12.509938 9.69743802,11.2517824 11.25,11.25 L33.75,11.25 C35.302562,11.2517824 36.5607176,12.509938 36.5625,14.0625 L36.5625,36.5625 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineLearningIcon);
export default __webpack_public_path__ + "static/media/machine-learning-icon.e3c1d4baad1150b6ae2215fdd3cc43dc.svg";
export { ForwardRef as ReactComponent };